// extracted by mini-css-extract-plugin
module.exports = {"navigation":"navigation_navigation__Axwdq","list-item":"navigation_list-item__NOP_e"};